module.exports = __webpack_public_path__ + "img/w64b.71eb6f80.jpg";